import { ComponentStyleConfig, SystemStyleFunction } from '@cloudbeds/payment-sdk';

const baseStyle: SystemStyleFunction = props => ({
  container: {
    borderWidth: '1px',
    borderColor: props.isInvalid ? `${props.theme.colors.error[500]}` : `${props.theme.colors.neutral[300]}`,
    backgroundColor: 'white.500',
    borderRadius: '8px',
    padding: '4px 16px',
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
  },
  helperText: {
    margin: 0,
    padding: 0,
    fontSize: 'sm',
    fontWeight: 400,
  },
});

export const Form: ComponentStyleConfig = {
  baseStyle,
};
